export default {
  COMPOSER: 'composer',
  GUEST: 'guest',
  ISO_STREAM_CAPTURE: 'iso-stream-capture',
  PORTAL: 'portal',
  STUDIO: 'studio',
  SOLO_RECORDER: 'solo-recorder',
};
